<ng-template field="field" ccFormFieldThumbnailHost></ng-template>
